module.exports = __webpack_public_path__ + "img/plan-upgrade.dc34dad8.png";